import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import '../styles/FaqModal.css';

const FAQS = [
  {
    q: 'Who is eligible to avail flexibility options under Smart Work policy?',
    a: 'M&SS associates (including TMTs) are eligible to avail flexibility options. Trainees/apprentices will be required to work from office in view of their nature of work which requires supervision.',
  },
  {
    q: 'How will I know the type of flexibility my role is eligible for as per Smart Work policy?',
    a: 'M&SS associate is expected to connect with the manager to clarify the flexibility option applicable to them as per the Smart Work policy. The eligibility of role/associate can be subject to change based on business requirement from time to time.',
  },
  {
    q: 'Who will be responsible to decide and approve the type of flexibility my role is eligible for if my disciplinary and target manager are different?',
    a: 'Your disciplinary manager will be responsible to confirm the same.',
  },
  {
    q: 'Can the M&SS associates working in plant locations also avail Flex working option?',
    a: 'Yes, flexibility criterion is purely based on nature of job and not restricted to any specific location. The M&SS associates in plants can also avail flex working option if the nature of job/work can be performed remotely and business continuity, customer/project deliverables, productivity & performance is not adversely impacted.',
  },
  {
    q: 'If I am completely aware that my work can be done effectively from home, but my manager does not agree. Can I still avail the WFH option?',
    a: 'As per policy, manager is responsible to decide & confirm whether the job can be performed at home productively. In case of any disagreement, an associate can escalate or seek clarifications from manager\'s manager and HR BP.',
  },
  {
    q: 'For those associates eligible for Flex working option, is it voluntary or mandated?',
    a: 'Voluntary. Eligible associates can work in the office full-time if they so choose.',
  },
  {
    q: 'Is there any geographic restriction on where an associate can work from under Flex option?',
    a: 'Associates eligible for Flex option must operate from base location & base office only.',
  },
  {
    q: 'Can I operate from office even if my role is eligible for WFH under Flex option?',
    a: 'Yes, all M&SS associates can operate from base office even if the role can be performed productively from home. The concept of flexible seating at office will be applicable suitably.',
  },
  {
    q: 'What should I do if I do not have enough broadband bandwidth/good connectivity at home?',
    a: 'M&SS associates WFH/WFA are eligible for an allowance of INR 1200 to cover cost for a good broadband with high-speed bandwidth. In case an associate does not have good network/bandwidth at home, he/she is expected to operate from office.',
  },
  {
    q: 'Can I operate from public places such as hospitals, hotels, restaurants, or cyber cafes?',
    a: 'No, associates are not allowed to operate from public places while WFH or WFA to avoid any risk attached to data privacy and cyber security.',
  },
  {
    q: 'Can I WFH from a location other than my base location for a short duration?',
    a: 'Yes, associates can work outside of the base location within India for a short duration based on Work from Anywhere (WFA) criteria and subject to alignment and approval from the manager.',
  },
  {
    q: 'Will I be eligible for travel reimbursement if I have opted WFA for personal reasons?',
    a: 'Associates opting for WFA for a specific duration (minimum 1 month or more) can be eligible for travel reimbursement only if they are expected to attend any in-person official meetings during the agreed WFA duration.',
  },
  {
    q: 'Can I WFH/WFA from a location outside the territory of India?',
    a: 'No, the current Smart Work policy does not allow working outside India due to tax-related liabilities on the individual and organisation.',
  },
  {
    q: 'Can I accumulate WFH days provided under @Office flexibility option and use them at a stretch?',
    a: 'No, accumulation of WFH days under any flexibility option is not allowed.',
  },
  {
    q: 'What happens to the applicable flexibility option if I am transferred to a new role/location/Bosch entity?',
    a: 'Smart Work is a Country Policy applicable to all Bosch locations and entities. The new manager will communicate the applicable flexibility option based on the nature of the new role.',
  },
  {
    q: 'Can my manager create a rotational model for my team?',
    a: 'Yes, managers can create a rotational model for their teams to ensure seamless day-to-day operations, productivity, collaboration, and business performance.',
  },
  {
    q: 'Can my manager call me to office at short notice?',
    a: 'Yes, all associates working under flex option are expected to operate from base location and can be requested to attend office at short notice based on work delivery and business need.',
  },
  {
    q: 'What should I do if I need to step out of home during office hours for a personal reason?',
    a: 'Keep the manager informed and apply half/full day leave as appropriate.',
  },
  {
    q: 'Am I eligible for an Office set-up allowance (INR 15,000)?',
    a: 'After careful consideration, it has been decided to discontinue the office set-up allowance for all M&SS associates with effect from January 2024.',
  },
  {
    q: 'Is the Broadband allowance applicable for all M&SS associates?',
    a: 'Broadband allowance is applicable for M&SS associates on active rolls of the company. Associates on STA/LTA, maternity leave, child raising leave, sabbatical leave or long medical leave can claim the allowance from the date of resuming work.',
  },
  {
    q: 'Is the Broadband allowance applicable to Trainees/Apprentices?',
    a: 'No. Broadband allowance is not applicable to Trainees/Apprentices since they are required to work from office.',
  },
  {
    q: 'Am I eligible for Broadband allowance even if I work from home only a few days?',
    a: 'Yes. The allowance is paid through monthly salary (taxable) without any bill submission, subject to timely self-declaration via ESS platform.',
  },
  {
    q: 'Is the Broadband allowance applicable to transfer cases from other entities?',
    a: 'Yes. Broadband allowance is applicable and can be claimed monthly as per the standard practice.',
  },
  {
    q: 'Am I eligible for Broadband allowance if transferred from RBIN to another entity?',
    a: 'Post transfer, an associate will be governed by the Smart Work policy conditions of the new entity.',
  },
  {
    q: 'I have a company-provided SIM card with data. Am I still eligible to claim the broadband allowance?',
    a: 'Yes, the employee is eligible to claim the broadband allowance.',
  },
  {
    q: 'I have a company dongle but have not used it. Am I eligible for broadband allowance?',
    a: 'If an associate is in possession of a company dongle, they are not eligible for the broadband allowance. If not currently using the dongle, they are expected to return it and then claim the allowance.',
  },
  {
    q: 'Can I claim broadband allowance due from last year?',
    a: 'Associates must claim the allowance within the same year. Only for the month of December, it may be claimed by 15th January of the following year.',
  },
  {
    q: 'Who should I reach out to for more clarity on Smart Work policy?',
    a: 'Please reach out to your respective HR BP for more clarity on Smart Work policy.',
  },
];

export default function FaqModal({ onClose }) {
  // Close on Escape key
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    // Prevent body scroll while modal is open
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const modal = (
    <div className="faq-overlay" onClick={onClose}>
      <div className="faq-modal" onClick={(e) => e.stopPropagation()}>
        <div className="faq-modal-header">
          <div>
            <h2 className="faq-modal-title">Smart Work Policy — FAQs</h2>
            <p className="faq-modal-subtitle">Internet Reimbursement eligibility &amp; broadband allowance</p>
          </div>
          <button className="faq-modal-close" onClick={onClose} aria-label="Close FAQ">✕</button>
        </div>

        <div className="faq-modal-body">
          {FAQS.map((item, idx) => (
            <div key={idx} className="faq-item">
              <div className="faq-q">
                <span className="faq-q-num">Q{idx + 1}</span>
                {item.q}
              </div>
              <div className="faq-a">{item.a}</div>
            </div>
          ))}
        </div>

        <div className="faq-modal-footer">
          <button className="faq-close-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
}
